import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-transport-statistics.component.html',
    selector: 'op-product-dashboard-transport-statistics'
})
export class ProductDashboardTransportStatisticsComponent implements AfterViewInit {
    public revenueYesterday: number;
    public revenueToday: number
    public cancellationYesterday: number;
    public cancellationToday: number;
    public revenueCancellationYesterday: number;
    public revenueCancellationToday: number;

    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.revenueYesterday = 1250;
            this.revenueToday = 5165;
            this.cancellationYesterday = 232;
            this.cancellationToday = 364;
            this.revenueCancellationYesterday = 500;
            this.revenueCancellationToday = 250;

            this.changeDetection.detectChanges();
        }, 500);
    }
}